import { render, staticRenderFns } from "./TpLoadingBar.vue?vue&type=template&id=9ec1f4bc&scoped=true&"
import script from "./TpLoadingBar.vue?vue&type=script&lang=js&"
export * from "./TpLoadingBar.vue?vue&type=script&lang=js&"
import style0 from "./TpLoadingBar.vue?vue&type=style&index=0&id=9ec1f4bc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec1f4bc",
  null
  
)

export default component.exports